import React, { Fragment } from 'react';
import classNames from 'classnames';
import Item from './components/Item';
import style from './networkBar.module.scss';

const NetworkBar = () => {
  const networksBar = window.ExternalConfig.networkNavigation;
  if (!networksBar) return null;
  const containerClasses = [style.container, style.redesignCollections];
  return (
    <div className={classNames(containerClasses)}>
      {networksBar.map(network => (
        <Fragment key={`network-bar-item-${network.label}`}>
          <Item {...network} />
        </Fragment>
      ))}
    </div>
  );
};

export default NetworkBar;
